import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './settings.css';
import Notification from '../../components/notification.js';

const Settings = () => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState({
    emailNotifications: true,
    darkMode: false,
    language: 'en',
    privacySettings: {
      profileVisibility: 'public',
      showEmail: false
    },
    twoFactorAuth: false
  });
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await fetch('http://localhost:4000/api/user/settings', {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch settings');
      }

      const data = await response.json();
      setSettings(data);
      setLoading(false);
    } catch (error) {
      setNotification({
        type: 'error',
        message: 'Failed to load settings. Please try again.'
      });
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      const response = await fetch('http://localhost:4000/api/user/settings/update', {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(settings)
      });

      if (!response.ok) {
        throw new Error('Failed to update settings');
      }

      setNotification({
        type: 'success',
        message: 'Settings updated successfully!'
      });
    } catch (error) {
      setNotification({
        type: 'error',
        message: 'Failed to update settings. Please try again.'
      });
    }
  };

  const handleChange = (section, field) => (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    
    if (section) {
      setSettings(prev => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value
        }
      }));
    } else {
      setSettings(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  const handleCloseNotification = () => {
    setNotification(null);
  };

  if (loading) {
    return <div className="settings-loading">Loading...</div>;
  }

  return (
    <div className="settings-container">
      <div className="settings-content">
        <h1 className="settings-title">Settings</h1>

        <section className="settings-section">
          <h2>Notifications</h2>
          <div className="settings-option">
            <label>
              <input
                type="checkbox"
                checked={settings.emailNotifications}
                onChange={handleChange(null, 'emailNotifications')}
              />
              Email Notifications
            </label>
          </div>
        </section>

        <section className="settings-section">
          <h2>Appearance</h2>
          <div className="settings-option">
            <label>
              <input
                type="checkbox"
                checked={settings.darkMode}
                onChange={handleChange(null, 'darkMode')}
              />
              Dark Mode
            </label>
          </div>
        </section>

        <section className="settings-section">
          <h2>Language</h2>
          <div className="settings-option">
            <select
              value={settings.language}
              onChange={handleChange(null, 'language')}
              className="settings-select"
            >
              <option value="en">English</option>
              <option value="es">Spanish</option>
              <option value="fr">French</option>
              <option value="de">German</option>
            </select>
          </div>
        </section>

        <section className="settings-section">
          <h2>Privacy</h2>
          <div className="settings-option">
            <label>Profile Visibility</label>
            <select
              value={settings.privacySettings.profileVisibility}
              onChange={handleChange('privacySettings', 'profileVisibility')}
              className="settings-select"
            >
              <option value="public">Public</option>
              <option value="private">Private</option>
              <option value="friends">Friends Only</option>
            </select>
          </div>
          <div className="settings-option">
            <label>
              <input
                type="checkbox"
                checked={settings.privacySettings.showEmail}
                onChange={handleChange('privacySettings', 'showEmail')}
              />
              Show Email on Profile
            </label>
          </div>
        </section>

        <section className="settings-section">
          <h2>Security</h2>
          <div className="settings-option">
            <label>
              <input
                type="checkbox"
                checked={settings.twoFactorAuth}
                onChange={handleChange(null, 'twoFactorAuth')}
              />
              Two-Factor Authentication
            </label>
          </div>
        </section>

        <div className="settings-actions">
          <button onClick={handleSave} className="settings-save-btn">
            Save Changes
          </button>
        </div>
      </div>

      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
};

export default Settings; 